import React, { Component } from 'react';

class PaymentCashButtons extends Component {
  render() {
    return(
      <div>
        <button type="button" onClick={event => this.props.handlePaymentCashButton(this.props.orderTotal)} className='btn btn-lg btn-success mt-1'>${this.props.orderTotal.toFixed(2)}</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentCashButton(2)} className='btn btn-lg btn-success mt-1'>$2.00</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentCashButton(5)} className='btn btn-lg btn-success mt-1'>$5.00</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentCashButton(10)} className='btn btn-lg btn-success mt-1'>$10.00</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentCashButton(20)} className='btn btn-lg btn-success mt-1'>$20.00</button>
        &nbsp;
        <button type="button" onClick={event => this.props.handlePaymentCashButton(50)} className='btn btn-lg btn-success mt-1'>$50.00</button>
      </div>
    );
  }
}

export default PaymentCashButtons;



// WEBPACK FOOTER //
// ./src/containers/payment_cash_buttons.js